var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"menu-item",attrs:{"href":"#"}},[_c('div',{staticClass:"menu-item-icon"},[(_vm.icon)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}):_vm._e()],1),_c('div',{staticClass:"menu-item-label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }